// extracted by mini-css-extract-plugin
module.exports = {"SectionA":"SectionA_SectionA__ea8IA"};